<template>
  <div>
    <v-card class="ma-2">
      <v-card-title>
        NFL Fantasy Player Props
        <v-spacer></v-spacer>
        <v-col cols="12" md="4" sm="5">
          <v-row justify="center" align="center">
            <small>Confidence :</small> <br/>&nbsp;
            <v-col class="light-green caption text-center"
            ><span>Low </span></v-col
            >
            <v-col class="medium-green caption text-center"
            ><span>Medium </span></v-col
            >
            <v-col class="dark-green caption text-center"
            ><span>High </span></v-col
            >
          </v-row>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="12" md="5" sm="3">
          <v-row align="center" justify="end">
            <!--            <v-col md="7" cols="7" sm="6">-->
            <!--              <v-text-field-->
            <!--                v-model="search"-->
            <!--                append-icon="mdi-magnify"-->
            <!--                label="Search Player"-->
            <!--                single-line-->
            <!--                dense-->
            <!--                outlined-->
            <!--                hide-details-->
            <!--              ></v-text-field>-->
            <!--            </v-col>-->

            <v-col cols="5" md="4" sm="3">
              <v-card-actions>
                <v-switch v-model="switch1" inset label="Props"></v-switch>
                <!--                <v-switch-->
                <!--                  class="px-2"-->
                <!--                  v-model="switch2"-->
                <!--                  :disabled="switch1 ? false : true"-->
                <!--                  inset-->
                <!--                  label="Confidence"-->
                <!--                  @change="enableConfidence"-->
                <!--                ></v-switch> -->
              </v-card-actions>
            </v-col>
          </v-row>
        </v-col>
        <!-- <v-col cols="5" md="2" sm="3"> -->

        <!-- </v-col> -->
        <!-- </v-row> -->
      </v-card-title>

      <!-- <v-row class="mt-n8" justify="center">
        <v-col cols="2" md="1" sm="6" align-self="center">
          <v-avatar size="36px">
            <img alt="Avatar" src="/favicon.ico" />
          </v-avatar>
        </v-col>
        <v-col cols="3" md="1" sm="6" align-self="center">
          <span>Projection</span>
        </v-col>

        <v-col cols="2" md="1" sm="6">
          <v-avatar size="36px">
            <img alt="Avatar" src="/img/monkeyKnife.jpeg" />
          </v-avatar>
        </v-col>

        <v-col cols="3" md="1" sm="6" align-self="center">
          <span>Prop Line</span>
        </v-col>
      </v-row> -->

      <v-card-subtitle class="overline font-weight-bold">
        Wide Receivers
      </v-card-subtitle>
      <!--//? WR -->
      <v-data-table
          :headers="computedWrHeaders"
          :items="nfl_props.data.WR"
          :items-per-page="3"
          class="elevation-1 projection-table"
          mobile-breakpoint="0"
          calculate-widths
          sort-by="Name"
          :search="search"
          hide-default-footer
      >
        <!-- header -->
        <template
            v-for="(h, index) in computedWrHeaders"
            v-slot:[`header.${h.value}`]="{ computedWrHeaders }"
        >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img"/></v-avatar>
          </span>

          <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
        </template>
        <!-- header -->

        <template v-slot:item.ProfilePic="{ item }">
          <!-- //* avatar -->
          <v-avatar width="35" height="40">
            <img :src="item.ProfilePic"/>
          </v-avatar>
          <!-- //* avatar ends-->
        </template>

        <!--//* matchup -->
        <template v-slot:item.Game="{ item }">
          <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
            {{ item.Opponent }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Team }}
            </span>
          </p>

          <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
            {{ item.Team }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Opponent }}
            </span>
          </p>
        </template>
        <!--//* matchup ends -->

        <!-- Receptions -->
        <template v-slot:item.CalReceptions="{ item }">
          <p v-if="item.CalReceptions == ''">_</p>
          <p v-else>{{ parseFloat(item.CalReceptions).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceReceptions="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalReceptions) >= 0 &&
              parseFloat(item.CalReceptions) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceptions) >= 15 &&
              parseFloat(item.CalReceptions) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceptions) > 33 &&
              parseFloat(item.CalReceptions) <= 50
            "
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalReceptions) < 0 &&
              parseFloat(item.CalReceptions) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceptions) <= -15 &&
              parseFloat(item.CalReceptions) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceptions) < -33 &&
              parseFloat(item.CalReceptions) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- ReceivingYards -->
        <template v-slot:item.CalReceivingYards="{ item }">
          <p v-if="item.CalReceivingYards == ''">_</p>
          <p v-else>{{ parseFloat(item.CalReceivingYards).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceReceivingYards="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalReceivingYards) > 0 &&
              parseFloat(item.CalReceivingYards) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) >= 15 &&
              parseFloat(item.CalReceivingYards) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) > 33 &&
              parseFloat(item.CalReceivingYards) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) < 0 &&
              parseFloat(item.CalReceivingYards) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) <= -15 &&
              parseFloat(item.CalReceivingYards) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) < -33 &&
              parseFloat(item.CalReceivingYards) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- Fantasy points -->
        <template v-slot:item.CalFantasyPoints="{ item }">
          <p v-if="item.CalFantasyPoints == ''">_</p>
          <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceFantasy="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) >= 15 &&
              parseFloat(item.CalFantasyPoints) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) > 33 &&
              parseFloat(item.CalFantasyPoints) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) <= -15 &&
              parseFloat(item.CalFantasyPoints) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < -33 &&
              parseFloat(item.CalFantasyPoints) >= -50
            "
          >
            Under
          </p>
        </template>

        <!--FantasyPassingCompletions -->
        <template v-slot:item.CalPassingCompletions="{ item }">
          <p v-if="item.CalPassingCompletions == ''">_</p>
          <p v-else>{{ parseFloat(item.CalPassingCompletions).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidencePassingComp="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalPassingCompletions) >= 0 &&
              parseFloat(item.CalPassingCompletions) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingCompletions) >= 15 &&
              parseFloat(item.CalPassingCompletions) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingCompletions) > 33 &&
              parseFloat(item.CalPassingCompletions) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalPassingCompletions) < 0 &&
              parseFloat(item.CalPassingCompletions) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingCompletions) <= -15 &&
              parseFloat(item.CalPassingCompletions) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingCompletions) < -33 &&
              parseFloat(item.CalPassingCompletions) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- PassingYards -->
        <template v-slot:item.CalPassingYards="{ item }">
          <p v-if="item.CalPassingYards == ''">_</p>
          <p v-else>{{ parseFloat(item.CalPassingYards).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidencePassingYards="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalPassingYards) >= 0 &&
              parseFloat(item.CalPassingYards) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingYards) >= 15 &&
              parseFloat(item.CalPassingYards) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingYards) > 33 &&
              parseFloat(item.CalPassingYards) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalPassingYards) < 0 &&
              parseFloat(item.CalPassingYards) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingYards) <= -15 &&
              parseFloat(item.CalPassingYards) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingYards) < -33 &&
              parseFloat(item.CalPassingYards) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- FantasyRushingYards -->
        <template v-slot:item.CalRushingYards="{ item }">
          <p v-if="item.CalRushingYards == ''">_</p>
          <p v-else>{{ parseFloat(item.CalRushingYards).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceRushingYards="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalRushingYards) >= 0 &&
              parseFloat(item.CalRushingYards) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRushingYards) >= 15 &&
              parseFloat(item.CalRushingYards) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalRushingYards) > 33 &&
              parseFloat(item.CalRushingYards) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalRushingYards) < 0 &&
              parseFloat(item.CalRushingYards) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRushingYards) <= -15 &&
              parseFloat(item.CalRushingYards) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalRushingYards) < -33 &&
              parseFloat(item.CalRushingYards) >= -50
            "
          >
            Under
          </p>
        </template>
      </v-data-table>

      <!--//? QB  -->
      <v-card-subtitle class="overline font-weight-bold">
        Quarterbacks
      </v-card-subtitle>
      <v-data-table
          :headers="computedQbHeaders"
          :items="nfl_props.data.QB"
          :items-per-page="3"
          class="elevation-1 projection-table"
          mobile-breakpoint="0"
          calculate-widths
          sort-by="Name"
          :search="search"
          hide-default-footer
      >
        <!-- header -->
        <template
            v-for="(h, index) in computedQbHeaders"
            v-slot:[`header.${h.value}`]="{ computedQbHeaders }"
        >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img"/></v-avatar>
          </span>

          <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
        </template>
        <!-- header -->

        <template v-slot:item.ProfilePic="{ item }">
          <!-- //* avatar -->
          <v-avatar width="35" height="40">
            <img :src="item.ProfilePic"/>
          </v-avatar>
          <!-- //* avatar ends-->
        </template>

        <!--//* matchup -->
        <template v-slot:item.Game="{ item }">
          <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
            {{ item.Opponent }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Team }}
            </span>
          </p>

          <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
            {{ item.Team }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Opponent }}
            </span>
          </p>
        </template>
        <!--//* matchup ends -->

        <!-- Passing completion -->
        <template v-slot:item.CalPassingCompletions="{ item }">
          <p v-if="item.CalPassingCompletions == ''">_</p>
          <p v-else>{{ parseFloat(item.CalPassingCompletions).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidencePassingCompletions="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalPassingCompletions) > 0 &&
              parseFloat(item.CalPassingCompletions) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingCompletions) >= 15 &&
              parseFloat(item.CalPassingCompletions) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingCompletions) > 33 &&
              parseFloat(item.CalPassingCompletions) <= 50
            "
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalPassingCompletions) < 0 &&
              parseFloat(item.CalPassingCompletions) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingCompletions) <= -15 &&
              parseFloat(item.CalPassingCompletions) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingCompletions) < -33 &&
              parseFloat(item.CalPassingCompletions) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- Passing Yards -->
        <template v-slot:item.CalPassingYards="{ item }">
          <p v-if="item.CalPassingYards == ''">_</p>
          <p v-else>{{ parseFloat(item.CalPassingYards).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidencePassingYards="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalPassingYards) >= 0 &&
              parseFloat(item.CalPassingYards) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingYards) >= 15 &&
              parseFloat(item.CalPassingYards) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingYards) > 33 &&
              parseFloat(item.CalPassingYards) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalPassingYards) < 0 &&
              parseFloat(item.CalPassingYards) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingYards) <= -15 &&
              parseFloat(item.CalPassingYards) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingYards) < -33 &&
              parseFloat(item.CalPassingYards) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- Fantasy points -->
        <template v-slot:item.CalFantasyPoints="{ item }">
          <p v-if="item.CalFantasyPoints == ''">_</p>
          <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceFantasy="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) >= 15 &&
              parseFloat(item.CalFantasyPoints) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) > 33 &&
              parseFloat(item.CalFantasyPoints) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) <= -15 &&
              parseFloat(item.CalFantasyPoints) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < -33 &&
              parseFloat(item.CalFantasyPoints) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- Rushing Yards -->
        <template v-slot:item.CalRushingYards="{ item }">
          <p v-if="item.CalRushingYards == ''">_</p>
          <p v-else>{{ parseFloat(item.CalRushingYards).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceRushingYards="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalRushingYards) >= 0 &&
              parseFloat(item.CalRushingYards) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRushingYards) >= 15 &&
              parseFloat(item.CalRushingYards) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalRushingYards) > 33 &&
              parseFloat(item.CalRushingYards) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalRushingYards) < 0 &&
              parseFloat(item.CalRushingYards) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRushingYards) <= -15 &&
              parseFloat(item.CalRushingYards) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalRushingYards) < -33 &&
              parseFloat(item.CalRushingYards) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- touchdown -->
        <template v-slot:item.CalPassingTouchdowns="{ item }">
          <p v-if="item.CalPassingTouchdowns == ''">_</p>
          <p v-else>{{ parseFloat(item.CalPassingTouchdowns).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceTouchdowns="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalPassingTouchdowns) >= 0 &&
              parseFloat(item.CalPassingTouchdowns) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingTouchdowns) >= 15 &&
              parseFloat(item.CalPassingTouchdowns) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingTouchdowns) > 33 &&
              parseFloat(item.CalPassingTouchdowns) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalPassingTouchdowns) < 0 &&
              parseFloat(item.CalPassingTouchdowns) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingTouchdowns) <= -15 &&
              parseFloat(item.CalPassingTouchdowns) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingTouchdowns) < -33 &&
              parseFloat(item.CalPassingTouchdowns) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- Interception -->
        <template v-slot:item.CalPassingInterceptions="{ item }">
          <p v-if="item.CalPassingInterceptions == ''">_</p>
          <p v-else>
            {{ parseFloat(item.CalPassingInterceptions).toFixed(2) }}%
          </p>
        </template>

        <template v-slot:item.confidenceInterceptions="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalPassingInterceptions) >= 0 &&
              parseFloat(item.CalPassingInterceptions) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingInterceptions) >= 15 &&
              parseFloat(item.CalPassingInterceptions) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingInterceptions) > 33 &&
              parseFloat(item.CalPassingInterceptions) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalPassingInterceptions) < 0 &&
              parseFloat(item.CalPassingInterceptions) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPassingInterceptions) <= -15 &&
              parseFloat(item.CalPassingInterceptions) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalPassingInterceptions) < -33 &&
              parseFloat(item.CalPassingInterceptions) >= -50
            "
          >
            Under
          </p>
        </template>
      </v-data-table>

      <!--//? RB -->
      <v-card-subtitle class="overline font-weight-bold">
        Running Backs
      </v-card-subtitle>
      <v-data-table
          :headers="computedRbHeaders"
          :items="nfl_props.data.RB"
          :items-per-page="3"
          class="elevation-1 projection-table"
          mobile-breakpoint="0"
          calculate-widths
          sort-by="Name"
          :search="search"
          hide-default-footer
      >
        <!-- header -->
        <template
            v-for="(h, index) in computedRbHeaders"
            v-slot:[`header.${h.value}`]="{ computedRbHeaders }"
        >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img"/></v-avatar>
          </span>

          <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
        </template>
        <!-- header -->

        <template v-slot:item.ProfilePic="{ item }">
          <!-- //* avatar -->
          <v-avatar width="35" height="40">
            <img :src="item.ProfilePic"/>
          </v-avatar>
          <!-- //* avatar ends-->
        </template>

        <!--//* matchup -->
        <template v-slot:item.Game="{ item }">
          <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
            {{ item.Opponent }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Team }}
            </span>
          </p>

          <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
            {{ item.Team }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Opponent }}
            </span>
          </p>
        </template>
        <!--//* matchup ends -->

        <template v-slot:item.CalRushingYards="{ item }">
          <p v-if="item.CalRushingYards == ''">_</p>
          <p v-else>{{ parseFloat(item.CalRushingYards).toFixed(2) }}%</p>
        </template>

        <!-- Receptions -->
        <template v-slot:item.confidenceRushingYards="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalRushingYards) > 0 &&
              parseFloat(item.CalRushingYards) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRushingYards) >= 15 &&
              parseFloat(item.CalRushingYards) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalRushingYards) > 33 &&
              parseFloat(item.CalRushingYards) <= 50
            "
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalRushingYards) < 0 &&
              parseFloat(item.CalRushingYards) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRushingYards) <= -15 &&
              parseFloat(item.CalRushingYards) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalRushingYards) < -33 &&
              parseFloat(item.CalRushingYards) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- ReceivingYards -->
        <template v-slot:item.CalReceptions="{ item }">
          <p v-if="item.CalReceptions == ''">_</p>
          <p v-else>{{ parseFloat(item.CalReceptions).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceReceptions="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalReceptions) > 0 &&
              parseFloat(item.CalReceptions) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceptions) >= 15 &&
              parseFloat(item.CalReceptions) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceptions) > 33 &&
              parseFloat(item.CalReceptions) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalReceptions) < 0 &&
              parseFloat(item.CalReceptions) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceptions) <= -15 &&
              parseFloat(item.CalReceptions) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceptions) < -33 &&
              parseFloat(item.CalReceptions) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- Fantasy points -->
        <template v-slot:item.CalFantasyPoints="{ item }">
          <p v-if="item.CalFantasyPoints == ''">_</p>
          <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceFantasy="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) >= 15 &&
              parseFloat(item.CalFantasyPoints) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) > 33 &&
              parseFloat(item.CalFantasyPoints) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) <= -15 &&
              parseFloat(item.CalFantasyPoints) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < -33 &&
              parseFloat(item.CalFantasyPoints) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- ReceivingYards -->
        <template v-slot:item.CalReceivingYards="{ item }">
          <p v-if="item.CalReceivingYards == ''">_</p>
          <p v-else>{{ parseFloat(item.CalReceivingYards).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceReceivingYards="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalReceivingYards) >= 0 &&
              parseFloat(item.CalReceivingYards) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) >= 15 &&
              parseFloat(item.CalReceivingYards) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) > 33 &&
              parseFloat(item.CalReceivingYards) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) < 0 &&
              parseFloat(item.CalReceivingYards) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) <= -15 &&
              parseFloat(item.CalReceivingYards) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) < -33 &&
              parseFloat(item.CalReceivingYards) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- Rushing Attempt -->
        <template v-slot:item.CalRushingAttempts="{ item }">
          <p v-if="item.CalRushingAttempts == ''">_</p>
          <p v-else>{{ parseFloat(item.CalRushingAttempts).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceRushingAttempts="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalRushingAttempts) >= 0 &&
              parseFloat(item.CalRushingAttempts) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRushingAttempts) >= 15 &&
              parseFloat(item.CalRushingAttempts) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalRushingAttempts) > 33 &&
              parseFloat(item.CalRushingAttempts) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalRushingAttempts) < 0 &&
              parseFloat(item.CalRushingAttempts) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRushingAttempts) <= -15 &&
              parseFloat(item.CalRushingAttempts) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalRushingAttempts) < -33 &&
              parseFloat(item.CalRushingAttempts) >= -50
            "
          >
            Under
          </p>
        </template>
      </v-data-table>

      <v-card-subtitle class="overline font-weight-bold">
        Tight End
      </v-card-subtitle>
      <v-data-table
          :headers="computedTeHeaders"
          :items="nfl_props.data.TE"
          :items-per-page="3"
          class="elevation-1 projection-table"
          mobile-breakpoint="0"
          calculate-widths
          sort-by="Name"
          :search="search"
          hide-default-footer
      >
        <!-- header -->
        <template
            v-for="(h, index) in computedTeHeaders"
            v-slot:[`header.${h.value}`]="{ computedTeHeaders }"
        >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img"/></v-avatar>
          </span>

          <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
        </template>
        <!-- header -->

        <template v-slot:item.ProfilePic="{ item }">
          <!-- //* avatar -->
          <v-avatar width="35" height="40">
            <img :src="item.ProfilePic"/>
          </v-avatar>
          <!-- //* avatar ends-->
        </template>

        <!--//* matchup -->
        <template v-slot:item.Game="{ item }">
          <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
            {{ item.Opponent }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Team }}
            </span>
          </p>

          <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
            {{ item.Team }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Opponent }}
            </span>
          </p>
        </template>
        <!--//* matchup ends -->

        <template v-slot:item.CalReceivingYards="{ item }">
          <p v-if="item.CalReceivingYards == ''">_</p>
          <p v-else>{{ parseFloat(item.CalReceivingYards).toFixed(2) }}%</p>
        </template>

        <!-- ReceivingYards -->
        <template v-slot:item.confidenceReceivingYards="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalReceivingYards) > 0 &&
              parseFloat(item.CalReceivingYards) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) >= 15 &&
              parseFloat(item.CalReceivingYards) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) > 33 &&
              parseFloat(item.CalReceivingYards) <= 50
            "
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) < 0 &&
              parseFloat(item.CalReceivingYards) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) <= -15 &&
              parseFloat(item.CalReceivingYards) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceivingYards) < -33 &&
              parseFloat(item.CalReceivingYards) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- ReceivingYards -->
        <template v-slot:item.CalReceptions="{ item }">
          <p v-if="item.CalReceptions == ''">_</p>
          <p v-else>{{ parseFloat(item.CalReceptions).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceReceptions="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalReceptions) > 0 &&
              parseFloat(item.CalReceptions) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceptions) >= 15 &&
              parseFloat(item.CalReceptions) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceptions) > 33 &&
              parseFloat(item.CalReceptions) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalReceptions) < 0 &&
              parseFloat(item.CalReceptions) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalReceptions) <= -15 &&
              parseFloat(item.CalReceptions) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalReceptions) < -33 &&
              parseFloat(item.CalReceptions) >= -50
            "
          >
            Under
          </p>
        </template>

        <!-- Fantasy points -->
        <template v-slot:item.CalFantasyPoints="{ item }">
          <p v-if="item.CalFantasyPoints == ''">_</p>
          <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceFantasy="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) >= 15 &&
              parseFloat(item.CalFantasyPoints) <= 33
            "
          >
            Over
          </p>
          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) > 33 &&
              parseFloat(item.CalFantasyPoints) <= 50
            "
          >
            Over
          </p>
          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) <= -15 &&
              parseFloat(item.CalFantasyPoints) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < -33 &&
              parseFloat(item.CalFantasyPoints) >= -50
            "
          >
            Under
          </p>
        </template>
      </v-data-table>
    </v-card>

    <!-- update Modal -->
    <div v-if="UpgradeModal" class="upgrade-dialog">
      <v-dialog
          overlay-opacity="0.97"
          persistent
          v-model="UpgradeModal"
          max-width="350"
      >
        <v-card>
          <v-toolbar dense color="#00E676" class="text-h6" dark>
            Get Full Access
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="text-center text-h6 font-weight-bold pa-1">
            Upgrade Now & Get Access to ALL Features.
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1 white--text" text @click="goBack">
              No, Thanks
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1 white--text" text @click="goToUpgrade">
              Upgrade Now
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- update Modal ends..-->
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'NflProjection',
  data() {
    return {
      switch1: true,
      switch2: false,
      UpgradeModal: false,
      search: '',
      wrHeader: [
        {
          text: '',
          value: 'ProfilePic',
          sortable: false,
          width: '70',
        },
        {
          text: 'Player Name',
          value: 'Name',
          width: '150',
        },
        {
          text: 'Team',
          value: 'Team',
          width: '110',
        },

        {
          text: 'Game',
          value: 'Game',
          width: '120',
        },

        //#Fantasy points..
        // {
        //   text: 'Fantasy points',
        //   value: 'FantasyFantasyPoints',
        //   width: '150',
        //   img: '/favicon.ico',
        // },

        // {
        //   text: 'O/U',
        //   value: 'MonkeyFantasyPoints',
        //   width: '150',
        //   // img: '/img/monkeyKnife.jpeg',
        // },

        // {
        //   text: '% Diff',
        //   value: 'CalFantasyPoints',
        //   width: '110',
        // },
        //
        // {
        //   text: 'Confidence',
        //   value: 'confidenceFantasy',
        //   sortable: false,
        //   width: '130',
        // },

        //#FantasyReception..
        {
          text: 'Rec',
          value: 'FantasyReceptions',
          img: '/favicon.ico',
          width: '110',

          class: 'black--text',
        },

        {
          text: 'O/U',
          value: 'MonkeyReceptions',
          // img: '/img/monkeyKnife.jpeg',
          width: '110',

          class: 'black--text',
        },

        {
          text: '% Diff',
          value: 'CalReceptions',
          width: '110',
          class: 'black--text',
        },

        {
          text: 'Confidence',
          value: 'confidenceReceptions',
          sortable: false,
          width: '120',
          class: 'black--text',
        },

        //#ReceivingYards
        {
          text: 'Rec Yds',
          value: 'FantasyReceivingYards',
          width: '110',
          img: '/favicon.ico',
        },

        {
          text: 'O/U',
          value: 'MonkeyReceivingYards',
          width: '110',
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: '% Diff',
          value: 'CalReceivingYards',
          width: '110',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidenceReceivingYards',
          width: '130',
        },

        //#FantasyPassingCompletions
        // {
        //   text: 'Pass Completions',
        //   value: 'FantasyPassingCompletions',
        //   width: '110',
        //   img: '/favicon.ico',
        //   class: 'black--text',
        // },
        //
        // {
        //   text: 'O/U',
        //   value: 'MonkeyPassingCompletions',
        //   width: '110',
        //   class: 'black--text',
        //   // img: '/img/monkeyKnife.jpeg',
        // },
        //
        // {
        //   text: '% Diff',
        //   value: 'CalPassingCompletions',
        //   width: '110',
        //   class: 'black--text',
        // },
        //
        // {
        //   text: 'Confidence',
        //   sortable: false,
        //   value: 'confidencePassingComp',
        //   width: '130',
        //   class: 'black--text',
        // },

        // #PassingYards
        // {
        //   text: 'Pass Yds',
        //   value: 'FantasyPassingYards',
        //   width: '110',
        //   img: '/favicon.ico',
        // },
        //
        // {
        //   text: 'O/U',
        //   value: 'MonkeyPassingYards',
        //   width: '110',
        //   // img: '/img/monkeyKnife.jpeg',
        // },
        //
        // {
        //   text: '% Diff',
        //   value: 'CalPassingYards',
        //   width: '110',
        // },
        //
        // {
        //   text: 'Confidence',
        //   sortable: false,
        //   value: 'confidencePassingYards',
        //   width: '130',
        // },

        // #FantasyRushingYards
        {
          text: 'Rush Yds',
          value: 'FantasyRushingYards',
          width: '110',
          img: '/favicon.ico',
          class: 'black--text',
        },

        {
          text: 'O/U',
          value: 'MonkeyRushingYards',
          width: '110',
          class: 'black--text',
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: '% Diff',
          value: 'CalRushingYards',
          width: '110',
          class: 'black--text',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidenceRushingYards',
          width: '130',
          class: 'black--text',
        },
      ],

      qbHeader: [
        {
          text: '',
          value: 'ProfilePic',
          sortable: false,
          width: '70',
        },
        {
          text: 'Player Name',
          value: 'Name',
          width: '150',
        },
        {
          text: 'Team',
          value: 'Team',
          width: '110',
        },

        {
          text: 'Game',
          value: 'Game',
          width: '120',
        },

        // *

        // {
        //   text: 'Fantasy points',
        //   value: 'FantasyFantasyPoints',
        //   width: '150',
        //   img: '/favicon.ico',
        //   class: 'black--text',
        // },
        //
        // {
        //   text: 'O/U',
        //   value: 'MonkeyFantasyPoints',
        //   width: '150',
        //   // img: '/img/monkeyKnife.jpeg',
        //
        //   class: 'black--text',
        // },

        // {
        //   text: '% Diff',
        //   value: 'CalFantasyPoints',
        //   width: '110',
        //   class: 'black--text',
        // },
        //
        // {
        //   text: 'Confidence',
        //   sortable: false,
        //   value: 'confidenceFantasy',
        //   width: '130',
        //   class: 'black--text',
        // },

        // *
        {
          text: 'Passing Completions',
          value: 'FantasyPassingCompletions',
          width: '150',
          img: '/favicon.ico',
        },

        {
          text: 'O/U',
          value: 'MonkeyPassingCompletions',
          width: '150',
          // img: '/img/monkeyKnife.jpeg',

          // class: 'blue--text',
        },

        {
          text: '% Diff',
          value: 'CalPassingCompletions',
          width: '110',

          // class: 'success--text',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidencePassingCompletions',
          width: '130',

          // class: 'success--text',
        },

        // *
        {
          text: 'Passing Yards',
          value: 'FantasyPassingYards',
          width: '150',
          img: '/favicon.ico',
          class: 'black--text',
        },

        {
          text: 'O/U',
          value: 'MonkeyPassingYards',
          width: '150',
          // img: '/img/monkeyKnife.jpeg',
          class: 'black--text',
        },

        {
          text: '% Diff',
          value: 'CalPassingYards',
          width: '110',
          class: 'black--text',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidencePassingYards',
          width: '130',
          class: 'black--text',
        },

        // *
        {
          text: 'Rushing Yards',
          value: 'FantasyRushingYards',
          width: '150',
          img: '/favicon.ico',
        },

        {
          text: 'O/U',
          value: 'MonkeyRushingYards',
          width: '150',
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: '% Diff',
          value: 'CalRushingYards',
          width: '110',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidenceRushingYards',
          width: '130',
        },

        // *
        {
          text: 'Touchdown',
          value: 'FantasyPassingTouchdowns',
          width: '150',
          img: '/favicon.ico',
          class: 'black--text',
        },

        {
          text: 'O/U',
          value: 'MonkeyPassingTouchdowns',
          width: '150',
          // img: '/img/monkeyKnife.jpeg',
          class: 'black--text',
        },

        {
          text: '% Diff',
          value: 'CalPassingTouchdowns',
          width: '110',
          class: 'black--text',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidenceTouchdowns',
          width: '130',
          class: 'black--text',
        },

        // *
        {
          text: 'Interception',
          value: 'FantasyPassingInterceptions',
          width: '150',
          img: '/favicon.ico',
        },

        {
          text: 'O/U',
          value: 'MonkeyPassingInterceptions',
          width: '150',
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: '% Diff',
          value: 'CalPassingInterceptions',
          width: '110',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidenceInterceptions',
          width: '130',
        },
      ],

      rbHeader: [
        {
          text: '',
          value: 'ProfilePic',
          sortable: false,
          width: '70',
        },
        {
          text: 'Player Name',
          value: 'Name',
          width: '150',
        },
        {
          text: 'Team',
          value: 'Team',
          width: '10',
        },

        {
          text: 'Game',
          value: 'Game',
          width: '120',
        },

        // *

        // {
        //   text: 'Fantasy points',
        //   value: 'FantasyFantasyPoints',
        //   width: '150',
        //   img: '/favicon.ico',
        //   class: 'black--text',
        // },
        //
        // {
        //   text: 'O/U',
        //   value: 'MonkeyFantasyPoints',
        //   width: '150',
        //   // img: '/img/monkeyKnife.jpeg',
        //   class: 'black--text',
        //
        //   // class: 'blue--text',
        // },

        // {
        //   text: '% Diff',
        //   value: 'CalFantasyPoints',
        //   width: '110',
        //   class: 'black--text',
        //
        //   // class: 'success--text',
        // },

        // {
        //   text: 'Confidence',
        //   sortable: false,
        //   value: 'confidenceFantasy',
        //   width: '130',
        //   class: 'black--text',
        // },

        // *
        {
          text: 'Rushing Yards',
          value: 'FantasyRushingYards',
          width: '150',
          img: '/favicon.ico',
        },

        {
          text: 'O/U',
          value: 'MonkeyRushingYards',
          width: '150',
          // img: '/img/monkeyKnife.jpeg',

          // class: 'success--text',
        },

        {
          text: '% Diff',
          value: 'CalRushingYards',
          width: '110',

          // class: 'success--text',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidenceRushingYards',
          width: '130',

          // class: 'success--text',
        },

        // *
        {
          text: 'Rec',
          value: 'FantasyReceptions',
          width: '110',
          img: '/favicon.ico',
          class: 'black--text',
        },

        {
          text: 'O/U',
          value: 'MonkeyReceptions',
          width: '110',
          // img: '/img/monkeyKnife.jpeg',
          class: 'black--text',
        },

        {
          text: '% Diff',
          value: 'CalReceptions',
          width: '110',
          class: 'black--text',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidenceReceptions',
          width: '130',
          class: 'black--text',
        },

        // *
        {
          text: 'Receiving Yards',
          value: 'FantasyReceivingYards',
          width: '110',
          img: '/favicon.ico',
          class: 'black--text',
        },

        {
          text: 'O/U',
          value: 'MonkeyReceivingYards',
          width: '110',
          // img: '/img/monkeyKnife.jpeg',
          class: 'black--text',
        },

        {
          text: '% Diff',
          value: 'CalReceivingYards',
          width: '110',
          class: 'black--text',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidenceReceivingYards',
          width: '130',
          class: 'black--text',
        },

        // *
        {
          text: 'Rushing Attempts',
          value: 'FantasyRushingAttempts',
          width: '110',
          img: '/favicon.ico',
          class: 'black--text',
        },

        {
          text: 'O/U',
          value: 'MonkeyRushingAttempts',
          width: '110',
          // img: '/img/monkeyKnife.jpeg',
          class: 'black--text',
        },

        {
          text: '% Diff',
          value: 'CalRushingAttempts',
          width: '110',
          class: 'black--text',
        },

        {
          text: 'Confidence',
          sortable: false,
          value: 'confidenceRushingAttempts',
          width: '130',
          class: 'black--text',
        },
      ],

      teHeader: [
        {
          text: '',
          value: 'ProfilePic',
          sortable: false,
          width: '70',
        },
        {
          text: 'Player Name',
          value: 'Name',
          width: '150',
        },
        {
          text: 'Team',
          value: 'Team',
          width: '110',
        },

        {
          text: 'Game',
          value: 'Game',
          width: '120',
        },

        // *

        // {
        //   text: 'Fantasy points',
        //   value: 'FantasyFantasyPoints',
        //   width: '150',
        //   img: '/favicon.ico',
        //   class: 'black--text',
        // },
        //
        // {
        //   text: 'O/U',
        //   value: 'MonkeyFantasyPoints',
        //   width: '150',
        //   // img: '/img/monkeyKnife.jpeg',
        //   class: 'black--text',
        // },

        // {
        //   text: '% Diff',
        //   value: 'CalFantasyPoints',
        //   width: '110',
        //   class: 'black--text',
        // },
        //
        // {
        //   text: 'Confidence',
        //   value: 'confidenceFantasy',
        //   sortable: false,
        //   width: '130',
        //   class: 'black--text',
        // },
        // *
        {
          text: 'Rec Yards',
          value: 'FantasyReceivingYards',
          width: '150',
          img: '/favicon.ico',
        },

        {
          text: 'O/U',
          value: 'MonkeyReceivingYards',
          width: '150',
          // img: '/img/monkeyKnife.jpeg',

          // class: 'success--text',
        },

        {
          text: '% Diff',
          value: 'CalReceivingYards',
          width: '110',

          // class: 'success--text',
        },

        {
          text: 'Confidence',
          value: 'confidenceReceivingYards',
          sortable: false,
          width: '130',

          // class: 'success--text',
        },

        // *
        {
          text: 'Rec',
          value: 'FantasyReceptions',
          width: '150',
          img: '/favicon.ico',
          class: 'black--text',
        },

        {
          text: 'O/U',
          value: 'MonkeyReceptions',
          width: '130',
          // img: '/img/monkeyKnife.jpeg',
          class: 'black--text',
        },

        {
          text: '% Diff',
          value: 'CalReceptions',
          width: '110',
          class: 'black--text',
        },

        {
          text: 'Confidence',
          value: 'confidenceReceptions',
          sortable: false,
          width: '130',
          class: 'black--text',
        },
      ],
    };
  },

  computed: {
    ...mapState('NflModule', ['nfl_props']),
    ...mapState('userModule', ['userState']),

    computedWrHeaders() {
      if (this.switch1) {
        return this.wrHeader;
      } else if (!this.switch1) {
        let newHeader = this.wrHeader.filter((column) => {
          return (
              !column.value.includes('MonkeyFantasyPoints') &&
              !column.value.includes('CalFantasyPoints') &&
              !column.value.includes('confidenceFantasy') &&
              !column.value.includes('MonkeyReceivingYards') &&
              !column.value.includes('CalReceivingYards') &&
              !column.value.includes('confidenceReceivingYards') &&
              !column.value.includes('MonkeyReceptions') &&
              !column.value.includes('CalReceptions') &&
              !column.value.includes('confidenceReceptions') &&
              !column.value.includes('MonkeyReceivingYards') &&
              !column.value.includes('CalReceivingYards') &&
              !column.value.includes('confidenceReceivingYards') &&
              !column.value.includes('MonkeyPassingCompletions') &&
              !column.value.includes('CalPassingCompletions') &&
              !column.value.includes('confidencePassingComp') &&
              !column.value.includes('MonkeyPassingYards') &&
              !column.value.includes('CalPassingYards') &&
              !column.value.includes('confidencePassingYards') &&
              !column.value.includes('MonkeyRushingYards') &&
              !column.value.includes('CalRushingYards') &&
              !column.value.includes('confidenceRushingYards')
          );
        });
        return newHeader;
      }
    },

    computedQbHeaders() {
      if (this.switch1) {
        return this.qbHeader;
      } else if (!this.switch1) {
        let newHeader = this.qbHeader.filter((column) => {
          return (
              !column.value.includes('MonkeyFantasyPoints') &&
              !column.value.includes('CalFantasyPoints') &&
              !column.value.includes('confidenceFantasy') &&
              !column.value.includes('MonkeyPassingCompletions') &&
              !column.value.includes('CalPassingCompletions') &&
              !column.value.includes('confidencePassingCompletions') &&
              !column.value.includes('MonkeyPassingYards') &&
              !column.value.includes('CalPassingYards') &&
              !column.value.includes('confidencePassingYards') &&
              !column.value.includes('MonkeyRushingYards') &&
              !column.value.includes('CalRushingYards') &&
              !column.value.includes('confidenceRushingYards') &&
              !column.value.includes('MonkeyPassingTouchdowns') &&
              !column.value.includes('CalPassingTouchdowns') &&
              !column.value.includes('confidenceTouchdowns') &&
              !column.value.includes('MonkeyPassingInterceptions') &&
              !column.value.includes('CalPassingInterceptions') &&
              !column.value.includes('confidenceInterceptions')
          );
        });
        return newHeader;
      }
    },

    computedRbHeaders() {
      if (this.switch1) {
        return this.rbHeader;
      } else if (!this.switch1) {
        let newHeader = this.rbHeader.filter((column) => {
          return (
              !column.value.includes('MonkeyFantasyPoints') &&
              !column.value.includes('CalFantasyPoints') &&
              !column.value.includes('confidenceFantasy') &&
              !column.value.includes('MonkeyRushingYards') &&
              !column.value.includes('CalRushingYards') &&
              !column.value.includes('confidenceRushingYards') &&
              !column.value.includes('MonkeyReceptions') &&
              !column.value.includes('CalReceptions') &&
              !column.value.includes('confidenceReceptions') &&
              !column.value.includes('CalReceivingYards') &&
              !column.value.includes('MonkeyRushingYards') &&
              !column.value.includes('confidenceReceivingYards') &&
              !column.value.includes('confidenceRushingAttempts') &&
              !column.value.includes('CalRushingAttempts') &&
              !column.value.includes('MonkeyRushingAttempts')
          );
        });
        return newHeader;
      }
    },

    computedTeHeaders() {
      if (this.switch1) {
        return this.teHeader;
      } else if (!this.switch1) {
        let newHeader = this.teHeader.filter((column) => {
          return (
              !column.value.includes('MonkeyFantasyPoints') &&
              !column.value.includes('CalFantasyPoints') &&
              !column.value.includes('confidenceFantasy') &&
              !column.value.includes('MonkeyReceivingYards') &&
              !column.value.includes('CalReceivingYards') &&
              !column.value.includes('confidenceReceivingYards') &&
              !column.value.includes('MonkeyReceptions') &&
              !column.value.includes('CalReceptions') &&
              !column.value.includes('confidenceReceptions')
          );
        });
        return newHeader;
      }
    },
  },

  created() {
    this.fetchNflPropsData();
  },

  beforeMount() {
    if (this.userState) {
      if (this.userState.plantype == 'Free') {
        this.UpgradeModal = true;
      } else {
        this.UpgradeModal = false;
      }
    }
  },

  methods: {
    fetchNflPropsData() {
      this.$store.dispatch('NflModule/getNflProps');
    },

    goBack() {
      this.$router.go(-1);
    },

    goToUpgrade() {
      this.$router.push({name: 'upgradePlan'});
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table
>>> .v-data-table__wrapper
> table
> thead
> tr:last-child
> th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

span.team-w-mg {
  /* display: flex !important; */
  float: left;
}

.theme--light.v-data-table
>>> .v-data-table__wrapper
> table
> thead
> tr:last-child
> th.black--text {
  background-color: #cfd8dc !important;
}

.projection-table >>> .v-data-table-header__icon {
  opacity: 1;
}

.light-green {
  background-clip: #99cc99;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.medium-green {
  background-color: #33cc66;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.dark-green {
  background-color: #336633;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}
</style>
